<div class="catalog-categories" [style.--backgroundGradient]="gradient" data-test="catalog-categories">
  <div class="flex--row column-gap catalog-categories__tile-wrapper" (scroll)="categoriesScrolled($event)">
    <div *ngFor="let catalogMainCategory of catalogCategories$ | async" class="flex--column flex--justify-center border-all--gray4 catalog-categories__tile">
      <button mat-button class="catalog-categories__button" data-test="catalog-category__tile" (click)="categorySelected.emit(catalogMainCategory)">
        <span class="text--truncated">{{ catalogMainCategory.description | uppercaseFirst }}</span>
      </button>
    </div>
  </div>
</div>
